<div class="row" style="height: 60%" data-cy="collage-publish-container">
  <div class="col-3 d-flex flex-column" data-cy="collage-publish-preview-column">
    <mat-label data-cy="collage-publish-preview-label">Previews:</mat-label>
    <img [src]="screenshotData" style="max-height:100%;" data-cy="collage-publish-preview-image">

  </div>

  <div class="col-7 d-flex flex-column" style="border-right: lightgrey 1px solid; margin-bottom: 1%" data-cy="collage-publish-email-column">

    <mat-form-field class="w-100" disabled="true" data-cy="collage-publish-email-field">
      <input [(ngModel)]="patientEmail" matInput placeholder="Email To:" data-cy="collage-publish-email-input">
    </mat-form-field>

    <mat-form-field data-cy="collage-publish-subject-field">
      <input matInput [(ngModel)]="subject" placeholder="Subject" data-cy="collage-publish-subject-input">
    </mat-form-field>

    <mat-form-field data-cy="collage-publish-body-field">
      <textarea [(ngModel)]="body" matInput placeholder="Message Body"
                cdkTextareaAutosize
                cdkAutosizeMinRows="8"
                cdkAutosizeMaxRows="8" data-cy="collage-publish-body-input">
      </textarea>
    </mat-form-field>

    <div data-cy="collage-publish-email-actions">
<!--      <button mat-raised-button class="tdox-btn tdox-btn-primary mr-2" style="width: 170px">-->
<!--        Add Attachments-->
<!--      </button>-->
      <button mat-raised-button class="tdox-btn tdox-btn-primary-d" style="width: 170px; float: end" (click)="send()" data-cy="collage-publish-send-button">
        Send
      </button>
    </div>
  </div>
  <div class="col-2 d-flex flex-column" data-cy="collage-publish-share-column">
    <mat-label data-cy="collage-publish-share-label">Share To:</mat-label>
    <a mat-raised-button class="tdox-btn tdox-btn-primary share" style="width: 150px; margin: auto" [href]="screenshotData" download="mergedImage" data-cy="collage-publish-download-button">
      Download Image(s)
    </a>
    <button mat-raised-button class="tdox-btn tdox-btn-primary share" style="width: 150px; margin: auto" data-cy="collage-publish-instagram-button">Instagram</button>

    <button mat-raised-button class="tdox-btn tdox-btn-primary share" style="width: 150px; margin: auto" data-cy="collage-publish-clinical-button">TDO Clinical</button>

    <button mat-raised-button class="tdox-btn tdox-btn-primary share" style="width: 150px; margin: auto" data-cy="collage-publish-university-button">TDO University</button>

  </div>

</div>

